var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "container" },
    [
      _c(
        "div",
        { staticClass: "handle-box" },
        [
          _c(
            "el-form",
            {
              ref: "queryCondition",
              staticClass: "searchForm",
              attrs: { model: _vm.queryCondition, "label-width": "120px" },
            },
            [
              _c(
                "el-row",
                [
                  _c(
                    "el-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "el-row",
                        { attrs: { gutter: 20 } },
                        [
                          _c(
                            "el-col",
                            { attrs: { span: 6 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: _vm.$t("fpaManage.permanent.fpaNo"),
                                    prop: "fpaNo",
                                  },
                                },
                                [
                                  _c("el-input", {
                                    staticStyle: { width: "100%" },
                                    attrs: { clearable: "" },
                                    model: {
                                      value: _vm.queryCondition.fpaNo,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.queryCondition,
                                          "fpaNo",
                                          $$v
                                        )
                                      },
                                      expression: "queryCondition.fpaNo",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "el-col",
                            { attrs: { span: 6 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  attrs: { label: "Product", prop: "fpaName" },
                                },
                                [
                                  _c("el-input", {
                                    staticStyle: { width: "100%" },
                                    attrs: { clearable: "" },
                                    model: {
                                      value: _vm.queryCondition.fpaName,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.queryCondition,
                                          "fpaName",
                                          $$v
                                        )
                                      },
                                      expression: "queryCondition.fpaName",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "el-col",
                            { attrs: { span: 6 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  staticClass: "flexBox",
                                  attrs: {
                                    label: _vm.$t(
                                      "fpaManage.permanent.agreementLife"
                                    ),
                                    prop: "agreementStartDate",
                                  },
                                },
                                [
                                  _c("el-date-picker", {
                                    staticStyle: { width: "100%" },
                                    attrs: {
                                      type: "date",
                                      placeholder: _vm.$t("common.selDate"),
                                      "value-format": "yyyy-MM-dd",
                                      "picker-options":
                                        _vm.AgreementPickerOptionsStart,
                                    },
                                    model: {
                                      value: _vm.queryCondition.startDate,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.queryCondition,
                                          "startDate",
                                          $$v
                                        )
                                      },
                                      expression: "queryCondition.startDate",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "el-col",
                            { attrs: { span: 6 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  staticClass: "flexBox",
                                  attrs: {
                                    label: "To",
                                    prop: "agreementEndDate",
                                  },
                                },
                                [
                                  _c("el-date-picker", {
                                    staticStyle: { width: "100%" },
                                    attrs: {
                                      type: "date",
                                      placeholder: _vm.$t("common.selDate"),
                                      "value-format": "yyyy-MM-dd",
                                      "picker-options":
                                        _vm.AgreementPickerOptionsEnd,
                                    },
                                    model: {
                                      value: _vm.queryCondition.endDate,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.queryCondition,
                                          "endDate",
                                          $$v
                                        )
                                      },
                                      expression: "queryCondition.endDate",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-collapse-transition",
                    [
                      _vm.isShow
                        ? _c(
                            "el-col",
                            { attrs: { span: 24 } },
                            [
                              _c(
                                "el-row",
                                { attrs: { gutter: 20 } },
                                [
                                  _c(
                                    "el-col",
                                    { attrs: { span: 6 } },
                                    [
                                      _c(
                                        "el-form-item",
                                        {
                                          attrs: {
                                            label: "Creator",
                                            prop: "createUser",
                                          },
                                        },
                                        [
                                          _c("el-input", {
                                            staticStyle: { width: "100%" },
                                            attrs: { clearable: "" },
                                            model: {
                                              value:
                                                _vm.queryCondition.createUser,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.queryCondition,
                                                  "createUser",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "queryCondition.createUser",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "el-col",
                                    { attrs: { span: 6 } },
                                    [
                                      _c(
                                        "el-form-item",
                                        {
                                          attrs: {
                                            label: "Status",
                                            prop: "status",
                                          },
                                        },
                                        [
                                          _c("ic-select", {
                                            staticStyle: { width: "100%" },
                                            attrs: {
                                              clearable: "",
                                              table: "TT_FPA_LTO",
                                              field: "STATUS",
                                            },
                                            model: {
                                              value: _vm.queryCondition.status,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.queryCondition,
                                                  "status",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "queryCondition.status",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-row",
                { attrs: { type: "flex", justify: "center", align: "middle" } },
                [
                  _c(
                    "el-button",
                    {
                      attrs: { size: "mini", type: "primary" },
                      on: { click: _vm.queryData },
                    },
                    [_vm._v("Search")]
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: { size: "mini", type: "primary" },
                      on: { click: _vm.restQueryFormThis },
                    },
                    [_vm._v("Reset")]
                  ),
                  _c(
                    "span",
                    {
                      staticClass: "arrowDown",
                      on: {
                        click: function ($event) {
                          _vm.isShow = !_vm.isShow
                        },
                      },
                    },
                    [
                      _vm._v(_vm._s(_vm.isShow ? "Fold" : "Unfold")),
                      _c("i", {
                        class: _vm.isShow
                          ? "el-icon-arrow-up iconBtn"
                          : "el-icon-arrow-down iconBtn",
                      }),
                    ]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-table",
        {
          ref: "tableList",
          attrs: {
            data: _vm.tableList,
            border: "",
            "highlight-current-row": "",
            "max-height": "540",
          },
          on: { "selection-change": _vm.handleSelectChange },
        },
        [
          _c("el-table-column", {
            attrs: {
              "show-overflow-tooltip": "",
              prop: "serialNo",
              label: _vm.$t("fpaManage.lto.serialNo"),
              "min-width": "120px",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c(
                      "div",
                      {
                        staticClass: "a-link",
                        on: {
                          click: function ($event) {
                            return _vm.toDetail(scope.row.ttFpaLtoId)
                          },
                        },
                      },
                      [_vm._v(_vm._s(scope.row.serialNo))]
                    ),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: {
              "show-overflow-tooltip": "",
              prop: "fpaNo",
              label: _vm.$t("fpaManage.permanent.fpaNo"),
              "min-width": "100px",
            },
          }),
          _c("el-table-column", {
            attrs: {
              "show-overflow-tooltip": "",
              prop: "fpaName",
              label: "Product Or Commodity Purchased",
              "min-width": "250px",
            },
          }),
          _c("el-table-column", {
            attrs: {
              "show-overflow-tooltip": "",
              prop: "agreementStartDate",
              label: _vm.$t("fpaManage.permanent.agreementStartDate"),
              "min-width": "120px",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _vm._v(
                      " " +
                        _vm._s(
                          _vm._f("dateFormatFilter")(
                            scope.row.agreementStartDate,
                            "YYYY-MM-DD"
                          )
                        ) +
                        " "
                    ),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: {
              "show-overflow-tooltip": "",
              prop: "agreementEndDate",
              label: _vm.$t("fpaManage.permanent.agreementEndDate"),
              "min-width": "120px",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _vm._v(
                      " " +
                        _vm._s(
                          _vm._f("dateFormatFilter")(
                            scope.row.agreementEndDate,
                            "YYYY-MM-DD"
                          )
                        ) +
                        " "
                    ),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: {
              "show-overflow-tooltip": "",
              prop: "supplierAbbreviation",
              label: _vm.$t("supplierManage.supplierAbbreviation"),
              "min-width": "180px",
            },
          }),
          _c("el-table-column", {
            attrs: {
              "show-overflow-tooltip": "",
              prop: "statusValue",
              label: _vm.$t("common.status"),
              "min-width": "80px",
            },
          }),
          _c("el-table-column", {
            attrs: {
              "show-overflow-tooltip": "",
              prop: "auditor",
              label: _vm.$t("fpaManage.permanent.logicStatus"),
              "min-width": "100px",
            },
          }),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "pagination" },
        [
          _c("el-pagination", {
            attrs: {
              "current-page": _vm.queryCondition.pageNum,
              "page-sizes": _vm.pageSizeList,
              "page-size": _vm.queryCondition.pageSize,
              layout: _vm.pageLayout,
              total: _vm.totalCount,
            },
            on: {
              "size-change": _vm.pageSizeChange,
              "current-change": _vm.pageNumberChange,
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }